export enum PersonStatementType {
    PESSOAL = 1,
    FAMILIAR,
    RELACIONAMENTO
}